type StringValue = string | ((...args: string[]) => string);
type LangDict = Record<string, StringValue>;

const STRINGS: Record<string, LangDict> = {
    cs: {
        loading:        'Načítání…',
        loadingRegion:  (name: string) => `Načítání ${name}…`,
        noRegions:      'Žádné regiony nejsou nakonfigurovány. Přidejte regiony v administraci.',
        saveView:       'Uložit pohled',
        saveSettings:   'Uložit nastavení',
        resetSettings:  'Obnovit výchozí',
        resetDone:      'Obnoveno!',
        saved:          'Uloženo!',
        errorSave:      'Chyba',
        moreInfo:       'Více informací →',
        scale:          'Měřítko',
        normalMap:      'Normálová mapa',
        on:             'ZAP',
        off:            'VYP',
        arHint:         'Namiřte na rovný povrch a klepněte pro umístění',
        arExit:         'Ukončit AR',
        arMove:         'Přesunout',
        arHide:         'Skrýt',
        arShow:         'Zobrazit',
        arSize:         'Velikost',
        arHeight:       'Výška',
        arElev:         'Náklon',
        shading:        'Vzhled',
        shadeColor:     'Barvy',
        shadeRelief:    'Relief',
        shadeSatellite: 'Satelit',
        lodDist:        'Vzdál. LOD',
        lodDebug:       'Zobrazit úrovně LOD',
        lodNear:        'Blízko',
        lodFar:         'Daleko',
        pois:           'Zájm. body',
        catAll:         'Vše',
        cities:         'Sídla',
        sizeTown:       'Město',
        sizeVillage:    'Vesnice',
        labelSize:      'Velikost popisků',
        labelOffset:    'Výška popisků',
        visRange:       'Dosah',
        rangeFalloff:   'Pokles dosahu',
        sizeSpread:     'Spread velikostí',
        sectionMap:     'Mapa',
        sectionData:    'Data',
        sectionSettings:'Nastavení',
        arUnsupported:  'Toto zařízení nebo prohlížeč nepodporuje AR. Pokud si myslíte, že vaše zařízení AR podporuje, zkuste jiný prohlížeč (např. Chrome na Androidu).',
        arUnsupportedIOS: 'AR není v tomto prohlížeči podporováno. Na iPhonu/iPadu zkuste aplikaci Mozilla WebXR Viewer, která AR ve webových prohlížečích na iOS/iPadOS podporuje.',
        helpTitle:        'Ovládání',
        helpDesktopTitle: 'Počítač (myš a klávesnice)',
        helpDesktopBody:  '<li>Tažení levým tlačítkem: otáčení pohledu</li><li>Tažení pravým tlačítkem: posun (pan)</li><li>Kolečko myši: přiblížení/oddálení</li><li>W A S D: let kamerou po terénu</li><li>Klik na značku: zobrazení zájmového bodu</li>',
        helpMobileTitle:  'Mobil (dotyk)',
        helpMobileBody:   '<li>Tažení jedním prstem: otáčení pohledu</li><li>Tažení dvěma prsty: posun (pan)</li><li>Sevření/roztažení prstů: přiblížení/oddálení</li><li>Klepnutí na značku: zobrazení zájmového bodu</li>',
        helpArTitle:      'Režim AR',
        helpArBody:       '<li>Klepněte na tlačítko „AR“ vpravo nahoře pro vstup do AR (podporovaná zařízení Android s Chrome)</li><li>Namiřte telefon na rovný povrch a klepnutím model umístěte</li><li>Sevřením/roztažením dvou prstů model zvětšíte nebo zmenšíte</li><li>Ikony panelu slouží k přepínání vzhledu, dat a nastavení AR (velikost, výška, náklon)</li><li>„Přesunout“ umístí model znovu, „Ukončit AR“ ukončí režim AR</li>',
    },
    en: {
        loading:        'Loading…',
        loadingRegion:  (name: string) => `Loading ${name}…`,
        noRegions:      'No regions configured yet. Add regions in the admin panel.',
        saveView:       'Save view',
        saveSettings:   'Save settings',
        resetSettings:  'Reset to defaults',
        resetDone:      'Reset!',
        saved:          'Saved!',
        errorSave:      'Error',
        moreInfo:       'More info →',
        scale:          'Scale',
        normalMap:      'Normal map',
        on:             'ON',
        off:            'OFF',
        arHint:         'Point at a flat surface and tap to place',
        arExit:         'Exit AR',
        arMove:         'Move',
        arHide:         'Hide',
        arShow:         'Show',
        arSize:         'Size',
        arHeight:       'Height',
        arElev:         'Elev',
        shading:        'Shading',
        shadeColor:     'Colour',
        shadeRelief:    'Relief',
        shadeSatellite: 'Satellite',
        lodDist:        'LOD dist',
        lodDebug:       'Show LOD levels',
        lodNear:        'Near',
        lodFar:         'Far',
        pois:           'POIs',
        catAll:         'All',
        cities:         'Cities',
        sizeTown:       'Town',
        sizeVillage:    'Village',
        labelSize:      'Label size',
        labelOffset:    'Label height',
        visRange:       'Vis. range',
        rangeFalloff:   'Range falloff',
        sizeSpread:     'Size spread',
        sectionMap:     'Map',
        sectionData:    'Data',
        sectionSettings:'Settings',
        arUnsupported:  'This device or browser does not support AR. If you believe your device supports AR, try a different browser (e.g. Chrome on Android).',
        arUnsupportedIOS: 'AR is not supported in this browser. On iPhone/iPad, try the Mozilla WebXR Viewer app, which supports AR in web browsers on iOS/iPadOS.',
        helpTitle:        'Controls',
        helpDesktopTitle: 'Desktop (mouse & keyboard)',
        helpDesktopBody:  '<li>Left-click drag: rotate the view</li><li>Right-click drag: pan</li><li>Scroll wheel: zoom in/out</li><li>W A S D: fly the camera across the terrain</li><li>Click a marker: view a point of interest</li>',
        helpMobileTitle:  'Mobile (touch)',
        helpMobileBody:   '<li>One-finger drag: rotate the view</li><li>Two-finger drag: pan</li><li>Pinch: zoom in/out</li><li>Tap a marker: view a point of interest</li>',
        helpArTitle:      'AR mode',
        helpArBody:       '<li>Tap the “AR” button (top-right) to enter AR — needs a supported Android device with Chrome</li><li>Point your phone at a flat surface, then tap to place the model</li><li>Pinch with two fingers to resize the placed model</li><li>Use the panel icons to change shading, data and AR settings (size, height, tilt)</li><li>“Move” repositions the model, “Exit AR” leaves AR mode</li>',
    },
};

const LANG_KEY = 'ar_map_lang';
let _lang: string = localStorage.getItem(LANG_KEY) ?? 'en';
const _listeners: Array<(lang: string) => void> = [];

export function getLang(): string { return _lang; }

export function setLang(lang: string): void {
    if (!STRINGS[lang]) return;
    _lang = lang;
    localStorage.setItem(LANG_KEY, lang);
    document.documentElement.lang = lang;
    _listeners.forEach(cb => cb(lang));
}

export function onLangChange(cb: (lang: string) => void): void {
    _listeners.push(cb);
}

export function t(key: string, ...args: string[]): string {
    const dict = STRINGS[_lang] ?? STRINGS['en'];
    const val  = dict[key] ?? STRINGS['en'][key] ?? key;
    return typeof val === 'function' ? val(...args) : val;
}

export async function detectLang(): Promise<void> {
    if (localStorage.getItem(LANG_KEY)) {
        document.documentElement.lang = _lang;
        return;
    }
    try {
        const { lang } = await fetch('/api/lang').then(r => r.json()) as { lang: string };
        setLang(lang || 'en');
    } catch {
        setLang('en');
    }
}
